"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useRef, useState } from "react";
import { cx } from "@/lib/tailwind-utils";
import { InsertVariableBar } from "./toolbar/components";
import { ToolbarMenu } from "./toolbar/components/toolbar-menu";

/** Width threshold (px) below which the toolbar auto-compacts. */
const COMPACT_THRESHOLD = 640;
interface FloatingToolbarProps {
  className?: string;
  /**
   * Extra controls appended to the right of the formatting buttons, inside the
   * same pill/row and separated by a divider — e.g. the email light/dark
   * preview toggle. Optional and additive: callers that omit it get the plain
   * formatting toolbar unchanged (mirrors `rightSlot` on the sibling Toolbar).
   */
  children?: ReactNode;
}
export function FloatingToolbar(t0) {
  const $ = _c(13);
  const {
    className,
    children
  } = t0;
  const containerRef = useRef(null);
  const [compact, setCompact] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const el = containerRef.current?.parentElement;
      if (!el) {
        return;
      }
      const ro = new ResizeObserver(t3 => {
        const [entry] = t3;
        setCompact(entry.contentRect.width < COMPACT_THRESHOLD);
      });
      ro.observe(el);
      return () => ro.disconnect();
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== className) {
    t3 = cx("sticky top-0 z-10 w-fit mx-auto", "flex items-center shadow-md border-t rounded-xl px-1 py-0.5", "bg-background/80 backdrop-blur-sm", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== compact) {
    t4 = <div className="flex items-center min-w-0 overflow-hidden"><ToolbarMenu compact={compact} /></div>;
    $[4] = compact;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <InsertVariableBar />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children) {
    t6 = children && <div className="ml-1 flex shrink-0 items-center border-l border-border pl-1">{children}</div>;
    $[7] = children;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t6) {
    t7 = <div ref={containerRef} className={t3}>{t4}{t5}{t6}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}